import {
    CommunityGamificationService,
    CommunityStoriesService,
    TourService,
    Story,
    StoriesByIdResponse,
    SasUploadLinkResponse,
    StoryImage,
    OpenAPI
} from "../../services/restserver-openapi";

// ===================================
// Gamification
// ===================================

export const getGamificationKudos = (checkKudosSinceDate: number) => {
    return CommunityGamificationService.getKudos(checkKudosSinceDate);
}

export const getLevelAndRankConfig = () => {
    return CommunityGamificationService.getLevelAndRankConfig();
}

export function setTokenGamificationInApi(identityToken: string) {
    OpenAPI.TOKEN = identityToken;
}

// ===================================
// Stories
// ===================================

const emptyStoriesResponse = (): StoriesByIdResponse =>
    ({
        stories: [],
        nextCursorId: undefined,
        nextCursorDate: undefined,
    } as unknown as StoriesByIdResponse);

export const getStories = async (
    tourId: number,
    limit: number,
    cursorId?: number,
    cursorDate?: number,
    sort?: string,
    accessKey?: string,
): Promise<StoriesByIdResponse> => {
    const res = await CommunityStoriesService.getStoriesByTourId(
        tourId,
        limit,
        cursorId,
        cursorDate,
        sort,
        accessKey
    );

    return (res ?? emptyStoriesResponse());
};

export const getStoriesByTourId = async (
    tourId: number,
    limit: number,
    cursorId?: number,
    cursorDate?: number,
    sort?: string,
    accessKey?: string,
): Promise<StoriesByIdResponse> => {
    const res = await CommunityStoriesService.getStoriesByTourId(
        tourId,
        limit,
        cursorId,
        cursorDate,
        sort,
        accessKey
    );

    return (res ?? emptyStoriesResponse());
};

export const getStoriesByCompundId = async (
    compoundId: number,
    limit: number,
    cursorId?: number,
    cursorDate?: number,
    sort?: string,
    minRating?: number,
    maxRating?: number,
): Promise<StoriesByIdResponse> => {
    const res = await CommunityStoriesService.getStoriesByCompoundId(
        compoundId,
        limit,
        cursorId,
        cursorDate,
        sort,
        minRating,
        maxRating
    );

    return (res ?? emptyStoriesResponse());
};

export const addStory = async (
    tourId: number,
    stayId: number,
): Promise<Story> => {
    return CommunityStoriesService.createStory(tourId, stayId);
};

export const modifyStory = async (
    story: Story
): Promise<Story> => {
    return CommunityStoriesService.updateStory(story);
};

export const deleteStoryById = async (
    storyId: number
): Promise<void> => {
    return CommunityStoriesService.deleteStory(storyId);
};

export const getAccessKey = async (
    tourId: number
): Promise<string> => {
    return TourService.getAccessKey(tourId);
};

export const createOrUpdateAccessKey = async (
    tourId: number
): Promise<string> => {
    return TourService.createOrUpdateAccessKey(tourId);
};

export const deleteAccessKey = async (
    tourId: number
): Promise<void> => {
    return TourService.deleteAccessKey(tourId);
};

export const getStoryUploadLink = async (
    storyId: number,
    fileExtension: string
): Promise<SasUploadLinkResponse> => {
    return CommunityStoriesService.getSasUploadLinkForStory(storyId, fileExtension);
};

export const confirmStoryImageUpload = async (
    storyId: number,
    remoteName: string,
    fileExtension: string
): Promise<StoryImage> => {
    return CommunityStoriesService.confirmImageUploadForStory(storyId, remoteName, fileExtension);
}
